export default __webpack_public_path__ + "zapway-mais-texto.svg?cde48ee55a940f5b4e2709e53faa747d";